<template>
    <a-drawer placement="right" :closable="true" :visible="visible" :width="drawerWidth" :destroyOnClose="true"
        :forceRender="true" :bodyStyle="bodyStyle" :wrapStyle="wrapStyle" wrapClassName="drawer" @close="onClose">
        <div class="drawer-box" style="width:100%;height:100%">
            <section style="margin-bottom: 1em;">
                <h4>
                    <b>原料设置</b>
                    <a-tooltip>
                        <template slot="title">选择参与料仓分配的原料</template>
                        <a-icon style="margin-left: .5em;" type="info-circle" />
                    </a-tooltip>
                </h4>
                <span>
                    <font style="color:red">*</font>分析原料：
                </span>
                <a-checkbox-group v-model="checkedMaterials" @change="onCheckedMaterialChange">
                    <a-checkbox v-for="item in materialList" :key="item.dataIndex" :value="item" :checked="true">
                        {{ item.rawName }}({{ item.rawCode }})
                    </a-checkbox>
                </a-checkbox-group>
            </section>
            <section>
                <h4>
                    <b>分配设置</b>
                    <a-tooltip>
                        <template slot="title">最大料仓数量＜已使用料仓数量</template>
                        <a-icon style="margin-left: .5em;" type="info-circle" />
                    </a-tooltip>
                </h4>
                <a-row style="margin: 1em 0">
                    <a-col :span="3">
                        <font style="color:red">*</font>最大料仓数量：
                    </a-col>
                    <a-col :span="5">
                        <a-input-number class="input-number" v-model="maxSiloNumber" :min="0" placeholder="设置最大料仓数量"
                            :disabled="!checkedMaterials.length" @change="onMaxSiloNumberChange" />
                    </a-col>
                    <a-col :span="3">
                        已使用料仓：
                    </a-col>
                    <a-col :span="5">
                        <a-input-number class="input-number" disabled :value="checkedMaterials.length" />
                    </a-col>
                    <a-button type="primary" @click="onSiloAnalyseClick">料仓分析</a-button>
                </a-row>
            </section>
            <section class="section-table">
                <h4> <b>分析结果</b> </h4>
                <div style="margin-bottom: 1em;">
                    <a-button type="primary" :disabled="tableData.length == 0"
                        @click="onClearBtnClick">清空分析结果</a-button>
                    <a-button style="margin-left: 2em;" :disabled="tableData.length == 0"
                        @click="onExportBtnClick">导出报表</a-button>
                </div>
                <a-table v-if="tableData.length == 0" :columns="tableColumns" :loading="tableLoading"></a-table>
                <div v-for="table, index in tableData" :key="index" style="margin-bottom: 1em;">
                    <a-table :columns="tableColumns" :loading="tableLoading"
                        :data-source="tableData[index].formulaTaskRawRespList" row-key="nutritionId" bordered
                        :pagination="false" :showHeader="index == 0">
                    </a-table>
                </div>
            </section>

        </div>

        <template #title>
            <a-page-header style="padding: 0;" title="料仓分配" sub-title="多配方中有原料竞争料仓的情况，通过料仓分配淘汰某一个或多个原料" />
        </template>

        <a-modal :visible="progressModalVisible" title="" :footer="null" :closable="false">
            <span>料仓分析中，请稍候...</span>
            <a-progress style="margin: 1em 0;" type="line" :width="1" :percent="siloProgress" />
            <div style="height: 2em;">
                <span v-show="totalCalculatedTimes">已计算{{ calculatedTimes }}次，共计{{ totalCalculatedTimes }}次</span>
                <a-icon v-show="!totalCalculatedTimes" type="loading" />
            </div>
        </a-modal>
    </a-drawer>
</template>

<script>
import { exportExcel } from "@/Utils/excel/Export2Excel";

const tableColumns = [
    {
        title: "序号",
        align: 'center',
        dataIndex: "idx",
        width: 30,
    },
    {
        title: "总成本",
        align: 'center',
        dataIndex: "totalPrice",
        width: 100,
    },
    {
        title: "总成本差异",
        align: 'center',
        dataIndex: "totalPriceDiff",
        ellipsis: true,
        width: 80,
    },
    {
        title: "平均成本",
        align: 'center',
        dataIndex: "avgPrice",
        width: 80,
        ellipsis: true,
    },
    {
        title: "平均成本差异",
        align: 'center',
        dataIndex: "avgPriceDiff",
        width: 80,
        ellipsis: true
    },
    {
        title: "差异比(%)",
        align: 'center',
        dataIndex: "avgPricePercentage",
        width: 100
    },
    {
        title: "原料代码",
        align: 'center',
        dataIndex: "code",
        ellipsis: true,
        width: 80,
    },
    {
        title: "原料名称",
        align: 'center',
        dataIndex: "name",
        width: 80,
        ellipsis: true,
    },
    {
        title: "原料用量(吨)",
        align: 'center',
        dataIndex: "uasge",
        width: 80,
        ellipsis: true
    }
];

export default {
    components: {
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        selectedRows: {
            type: Array,
            default: () => []
        },
        taskId: {
            type: String,
            default: ''
        },
        taskName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            checkedMaterials: [],
            lastCheckedMaterials: [],
            materialList: [],
            maxSiloNumber: null,
            siloProgress: 0,
            tableColumns,
            tableData: [],
            tableLoading: false,
            scrollX: 1140,
            drawerWidth: 1200,
            wrapStyle: {
                overflow: 'hidden'
            },
            bodyStyle: {
                overflow: 'hidden',
            },
            progressModalVisible: false,
            calculatedTimes: 0,
            totalCalculatedTimes: 0,

            siloAnalyseBtnLoading: false,
            clearBtnLoading: false
        };
    },
    watch: {
        visible(val) {
            if (val) {
                this.checkedMaterials = this.materialList = this.selectedRows;
                this.getData();
            }
        },
    },
    mounted() {
        const viewportWidth = window.innerWidth;
        const _width = viewportWidth * 0.8;
        if (_width < 1200) {
            this.drawerWidth = _width;
            this.scrollX = _width - 80;
        }
    },
    methods: {
        // 获取表格
        getData() {
            this.tableData = [];
            const params = { "taskId": this.taskId };
            this.tableLoading = true;
            this.$get('/nhf-app/formulaRemoteCallback/getMultiFormulaTaskSiloFromRedis', params).then(res => {
                if (res.success) {
                    res.data.sort((a, b) => a.totalPrice - b.totalPrice);
                    res.data.forEach((item, index) => {
                        if (item.formulaTaskRawRespList.length > 0) {
                            item.formulaTaskRawRespList.sort((a, b) => a.uasge - b.uasge);
                            item.formulaTaskRawRespList[0].idx = index + 1;
                            item.formulaTaskRawRespList[0].totalPrice = item.totalPrice.toFixed(3);
                            item.formulaTaskRawRespList[0].totalPriceDiff = item.totalPriceDiff.toFixed(3);
                            item.formulaTaskRawRespList[0].avgPrice = item.avgPrice.toFixed(3);
                            item.formulaTaskRawRespList[0].avgPriceDiff = item.avgPriceDiff.toFixed(3);
                            item.formulaTaskRawRespList[0].avgPricePercentage = (item.avgPricePercentage * 100).toFixed(3);
                            item.formulaTaskRawRespList.forEach(rawRes => { rawRes.uasge = rawRes.uasge.toFixed(3); });
                        }
                    });

                    this.tableData = res.data;
                }
                this.tableLoading = false;
            });
        },
        // 料仓分析
        silo() {
            const data = {
                "maxSiloNum": this.maxSiloNumber,
                "optimizationType": "3",
                "algorithmType": "5",
                "rawCodeList": this.checkedMaterials.map(item => item.rawCode),
                "taskId": this.taskId,
                "useSiloNum": this.checkedMaterials.length
            };
            this.siloAnalyseBtnLoading = true;
            this.$post('/nhf-app/formulaRemoteCal/asyncTaskSiloBySpeedOptimization', data).then(res => {
                if (res.success) {
                    // 开始获取进度
                    this.siloProgress = 0;
                    this.totalCalculatedTimes = 0;
                    this.calculatedTimes = 0;
                    this.siloAnalyseBtnLoading = false;
                    this.getSiloProgress();
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        getSiloProgress() {
            this.progressModalVisible = true;
            const timer = setInterval(() => {
                const params = { "taskId": this.taskId };
                this.$get('/nhf-app/formulaRemoteCallback/getMultiFormulaTaskSiloProgress', params).then(res => {
                    if (res.success) {
                        this.siloProgress = res.data.progressPer * 100;
                        if (this.siloProgress > 0) {
                            this.siloProgress = Number(this.siloProgress.toFixed(1));
                        }
                        this.totalCalculatedTimes = res.data.totalCalculatedTimes;
                        this.calculatedTimes = res.data.calculatedTimes ? res.data.calculatedTimes : 0;
                        if (res.data.progressPer == 1) {
                            clearInterval(timer);
                            setTimeout(() => {
                                this.progressModalVisible = false;
                            }, 500);
                            this.getData();
                        }
                    }
                });
            }, 1000);
        },
        onCheckedMaterialChange(val) {
            if (val.length == 0) {
                this.$message.warn('必须选中至少一项');
                this.checkedMaterials = this.lastCheckedMaterials;
            } else {
                this.lastCheckedMaterials = val;
            }
        },
        onMaxSiloNumberChange() {

        },
        // 料仓分析
        onSiloAnalyseClick() {
            if (this.maxSiloNumber == null || this.maxSiloNumber == 0) {
                this.$message.warn('无可用料仓，请检查设置');
                return;
            }
            if (this.maxSiloNumber >= this.checkedMaterials.length) {
                this.$message.warn('最大料仓数与已使用料仓数相同，无法进行料仓分析');
                return;
            }
            this.$confirm({
                title: '料仓分析',
                content: '确定进行料仓分析吗?',
                cancelText: '取消',
                okText: '确定',
                icon: 'info-circle',
                confirmLoading: this.siloAnalyseBtnLoading,
                onOk: () => {
                    this.silo();
                },
                onCancel: () => { }
            });
        },
        onClearBtnClick() {
            this.$confirm({
                title: '清空分析结果',
                content: '确定清空分析结果吗？',
                cancelText: '取消',
                okText: '确定',
                icon: 'info-circle',
                confirmLoading: this.clearBtnLoading,
                onOk: () => {
                    this.clearBtnLoading = true;
                    const params = { "taskId": this.taskId };
                    this.$get('/nhf-app/formulaRemoteCallback/clearFormulaTaskSiloResult', params).then(res => {
                        if (res.success) {
                            this.clearBtnLoading = false;
                            this.tableData = [];
                            this.$message.success('清除成功');
                        }
                    });
                },
                onCancel: () => { }
            });
        },
        onExportBtnClick() {
            let tHeader = this.tableColumns.map((item) => {
                return item.title || '名称';
            });
            let filterVal = this.tableColumns.map((item) => item.dataIndex);
            let tTitle = `${this.taskName}-${new Date().getTime()}`;
            const list = this.tableData.reduce((a, b) => a.concat(b.formulaTaskRawRespList), []);
            const data = this.formatJson(filterVal, list);
            exportExcel(tHeader, data, tTitle);
        },
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => {
                return v[j];
            }));
        },

        onClose() {
            this.$emit('close');
        },
    }
};
</script>


<style lang="scss" scoped>
.containers {
    width: 100%;
    flex: 1;
    height: calc(100vh - 100px);
}

::v-deep .drawer {
    overflow: hidden;

    .ant-drawer-wrapper-body,
    .ant-drawer-wrapper-body {
        overflow: hidden;
    }
}

::v-deep .ant-checkbox-wrapper-disabled {
    display: none;
}

.input-number {
    width: 100%;
    position: relative;
    left: -2em;
}

.section-table {
    .ant-btn {
        padding: 0 1em;
    }

    .ant-btn-primary {
        background-color: orange;
        border-color: orange;
    }

    .ant-btn-primary[disabled] {
        border-color: #d9d9d9;
        background-color: #f5f5f5;
    }
}

footer {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 56px;
    border-top: 1px solid #e9e9e9;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.08);
    padding: 10px 16px;
    background: #fff;
    text-align: right;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .ant-btn {
        margin-right: 20px;
        min-width: 60px;
    }

    >div {
        display: flex;
        align-items: center;
    }
}
</style>
